import { Action } from '@ngrx/store';		

export enum TestState  {
  INIT = 'Init aberration state'
}

export class InitTestState implements Action {
  readonly type = TestState.INIT;
  constructor(){}
}			